import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { HiPlus, HiMinus } from 'react-icons/hi';

import CartFooter from "../../common/CartFooter";

function RescheduleAppointmentStep2() {

    const [isOpened, setIsOpened] = useState(false);
    function toggle() {
        setIsOpened(wasOpened => !wasOpened);
    }

    return(
        
        <>
        {!isOpened && ( 
            <>
            <div className="container">
             <div className="cart-wrap">
                <div className="cart-list">
                    <h2 className="title left">reschedule appointment</h2>
                    <div className="cart-list-group">
                        <h3>treatments</h3>
                        <div className="table-div">
                        <div className="table-row thead">
                            <div className="table-col head">Name</div>
                            <div className="table-col head">Quantity</div>
                            <div className="table-col head">Appointment</div>
                            <div className="table-col head"></div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/lip-filter.png')} /></div>
                                    <span>Lip filler</span>
                                </div>
                            </div>
                            <div className="table-col">
                                <div className="qty-box">
                                    <div className="qty-icon"><HiMinus/></div>
                                    <div className="qty-input">
                                        <input value="0.5 ml" type="text" />
                                    </div>
                                    <div className="qty-icon"><HiPlus/></div>
                                </div>
                            </div>
                            <div className="table-col"><Link to="/patient-details" className="themeBtn line">update</Link></div>
                            <div className="table-col itemClose"><img alt="" src={require('../../images/icons/close-single.png')} /></div>
                        </div>
                        
                        <div className="table-row-extend">
                            <p>Appointment date & time: <span>01 October 2022, 12:30 PM.</span></p>
                            <p>Clinic address: <span>Bank Station (London underground)</span></p>
                            <div className="d-flex align-items-center">
                              <img alt="" src={require('../../images/icons/warning.png')} />
                              <p className="ps-2">Price: <span>£ 27.99</span>, this appointment is non-refundable.</p>
                            </div>
                        </div>

                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/bum.jpg')} /></div>
                                    <span>Brazilian bum lift consultation</span>
                                </div>
                            </div>
                            <div className="table-col">
                                <span>1</span>
                            </div>
                            <div className="table-col"><Link to="/patient-details" className="themeBtn line">update</Link></div>
                            <div className="table-col itemClose"><img alt="" src={require('../../images/icons/close-single.png')} /></div>
                        </div>

                        <div className="table-row-extend">
                            <p>Appointment date & time: <span>01 October 2022, 12:30 PM.</span></p>
                            <p>Clinic address: <span>Bank Station (London underground)</span></p>
                            <div className="d-flex align-items-center">
                              <img alt="" src={require('../../images/icons/warning.png')} />
                              <p className="ps-2">Price: <span>£ 27.99</span>, this appointment is non-refundable.</p>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
             </div>
          </div>

          <div className="cart-footer">
              <div className="container">
                  <div className="price-cont">
                    <span>Total price :</span>
                    <span>£ - 10.99</span>
                  </div>
                  <div className="priceButton">
                    <button className="themeBtn line red">Cancel Appointment</button>
                    <button className="themeBtn">Continue to payment</button>
                  </div>
              </div>

              <CartFooter/>

          </div>
            </>
        )}


        </>
    )
}

export default RescheduleAppointmentStep2;